// Imports ------------------------------------------------------------------->

import {LoyaltyProgram} from "../definitions/CommonDefinitions";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export function isValidProgramInput(program: LoyaltyProgram, input: string[]) {
	/* Wrap this entire function in a try/catch. Some of the RegExp strings returned from Accounts
		* cannot be parsed by the javascript RegExp implementation, so let the input pass */
	try {
		if (program.validationMethod === "cardonly") {
			const validator = new RegExp(program.cardRegex);
			return [validator.test(input[0]), true];
		} else if (program.validationMethod === "phoneandpin") {
			const phoneValidator = new RegExp(program.phoneRegex);
			const pinValidator = new RegExp(program.pinRegex);
			return [phoneValidator.test(input[0]), pinValidator.test(input[1])];
		} else if (program.validationMethod === "phoneonly") {
			const validator = new RegExp(program.phoneRegex);
			return [validator.test(input[0]), true];
		} else if (program.validationMethod === "cardorphone") {
			if (this.state.cardOrPhoneValue === "card") {
				const validator = new RegExp(program.cardRegex);
				return [validator.test(input[0]), true];
			} else if (this.state.cardOrPhoneValue === "phone") {
				const validator = new RegExp(program.phoneRegex);
				return [validator.test(input[0]), true];
			}
		}
		return [true, true];
	} catch (err) {
		return [true, true];
	}
}
